import { useMemo } from 'react';
import { Box } from '@mui/material';
import { QueryRule } from '../../../../../types/QueryBuilder';
import { useLanguage } from '../../../../../context/LanguageContext';
import ValueEditor from '../ValueEditors';
import CheckboxEditor from '../ValueEditors/CheckboxEditor';
import FieldLabel from './FieldLabel';
import { resolveFieldValues } from './fieldValues';
import { PairedRowProps, ruleIdOf } from './rowProps';

function OptinStatusRow({ field, rule, pairedField, pairedRule, onUpdateField }: PairedRowProps) {
    const { t } = useLanguage();
    const statusValues = useMemo(() => resolveFieldValues(pairedField, t), [pairedField, t]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <FieldLabel field={field} />
                <ValueEditor
                    ruleId={ruleIdOf(field, rule)}
                    field={field}
                    operator={rule?.operator || field.defaultOperator || '='}
                    value={rule?.value}
                    onChange={(value: QueryRule['value']) => onUpdateField(field.name, { value })}
                    compact
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pt: 1.5, borderTop: '1px solid', borderColor: 'divider' }}>
                <FieldLabel field={pairedField} />
                <CheckboxEditor
                    ruleId={ruleIdOf(pairedField, pairedRule)}
                    value={pairedRule?.value}
                    values={statusValues}
                    onChange={(value) => onUpdateField(pairedField.name, { value })}
                    compact
                />
            </Box>
        </Box>
    );
}

export default OptinStatusRow;
